import type { DeepLinkOpenedData } from "./types";
import {
  getQuizResultId,
  upsertQuizResultId,
} from "@/src/hooks/onboarding/quizResultContextStorage";

/** 从原生 payload 提取 resultId（顶层 → businessQuery → url query）。 */
export function extractResultId(
  data: DeepLinkOpenedData | null | undefined,
): string | undefined {
  if (!data) {
    return undefined;
  }
  const top = data.resultId?.trim();
  if (top) {
    return top;
  }
  const fromQuery = data.businessQuery?.resultId?.trim();
  if (fromQuery) {
    return fromQuery;
  }
  const rawUrl = data.url?.trim();
  if (!rawUrl) {
    return undefined;
  }
  try {
    const parsed = new URL(rawUrl);
    const fromUrl = parsed.searchParams.get("resultId")?.trim();
    return fromUrl || undefined;
  } catch {
    return undefined;
  }
}

/**
 * 沿用 deepLinkSession 的外部接口，内部统一委托给 onboarding 的
 * resultId 业务态 localStorage，避免 bridge 层和业务层各维护一套状态。
 */
export function persistDeepLinkResultId(
  data: DeepLinkOpenedData | null | undefined,
): string | undefined {
  const resultId = extractResultId(data);
  if (!resultId) {
    return resultId;
  }
  upsertQuizResultId(resultId);
  return resultId;
}

export function readPersistedDeepLinkResultId(): string | undefined {
  return getQuizResultId() ?? undefined;
}

/** 统一处理 deep-link-opened / get-last-deep-link 响应。 */
export function applyDeepLinkPayload(data: DeepLinkOpenedData): {
  route?: string;
  resultId?: string;
} {
  const resultId = persistDeepLinkResultId(data);
  return { resultId };
}
